export default "__VITE_ASSET__p$DfM_w2__"